var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446 441",
    width: 446,
    height: 441,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 163.2,
    y1: 228.7,
    x2: 102.5,
    y2: 184.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 217.4,
    y1: 280.7,
    x2: 151.6,
    y2: 249,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 256.7,
    y1: 298.6,
    x2: 147.2,
    y2: 267.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g4",
    cx: 187.6,
    cy: 41.6,
    r: 155.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 178.2,
    cy: 61.9,
    r: 145.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 185.8,
    cy: 60.1,
    r: 145.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g7",
    cx: 163.5,
    cy: 46.2,
    r: 68.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 243.2,
    y1: 283.3,
    x2: 145.9,
    y2: 307,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbeff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 217.2,
    y1: 277.8,
    x2: 191.8,
    y2: 253.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbeff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g10",
    cx: 160.8,
    cy: 263.8,
    r: 176.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g11",
    cx: 165.7,
    cy: 152.4,
    r: 41.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g12",
    cx: 157.7,
    cy: 150.1,
    r: 95,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g13",
    cx: 172.4,
    cy: 63.4,
    r: 139.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g14",
    cx: 106.6,
    cy: 105.3,
    r: 284.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0d0c6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 193.4,
    y1: 308,
    x2: 133.8,
    y2: 286.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 229.3,
    y1: 336.4,
    x2: 166.3,
    y2: 308.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g17",
    cx: 115.5,
    cy: 252.6,
    r: 110,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g18",
    cx: 212.7,
    cy: 111.1,
    r: 145.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g19",
    cx: 136.4,
    cy: 146.9,
    r: 112.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254.16 230.21l-0.88-0.51c-3.26-1.88-2.85-5.17 0.91-7.34l26.53-15.32c3.77-2.17 9.46-2.41 12.72-0.53l0.88 0.51c3.26 1.88 2.85 5.17-0.91 7.34l-26.54 15.32c-3.76 2.17-9.45 2.41-12.71 0.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g20",
    cx: 259.5,
    cy: 199.2,
    r: 72.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0d0c6f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g21",
    cx: 250.9,
    cy: 196,
    r: 49.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 39.6,
    y1: 153.4,
    x2: 289.1,
    y2: 153.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42e8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761d7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g23",
    cx: 36.8,
    cy: 198.7,
    r: 259.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g24",
    cx: 26,
    cy: 179.1,
    r: 317.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g25",
    cx: 143,
    cy: 131.8,
    r: 203.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5010dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g26",
    cx: 200.6,
    cy: 107.1,
    r: 143.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g27",
    cx: 74.1,
    cy: 178.8,
    r: 57.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3919bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 75.2,
    y1: 163.4,
    x2: 98.1,
    y2: 163.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 77.4,
    y1: 164.5,
    x2: 95.9,
    y2: 164.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f1fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a92ffb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 76.9,
    y1: 164.5,
    x2: 95.5,
    y2: 164.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f1fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a92ffb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 77.4,
    y1: 164.5,
    x2: 100.7,
    y2: 164.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#740df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8975b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g32",
    cx: 72.4,
    cy: 164.5,
    r: 48.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 85.2,
    y1: 174.7,
    x2: 88.4,
    y2: 174.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#740df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8975b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 306.9,
    y1: 357.1,
    x2: 89.7,
    y2: 357.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 281.5,
    y1: 324.1,
    x2: 239.6,
    y2: 324.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 430.8,
    y1: 331.7,
    x2: 167.5,
    y2: 331.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b04f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g37",
    cx: 325.3,
    cy: 126.5,
    r: 51.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g38",
    cx: 371.3,
    cy: 101,
    r: 101.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g39",
    cx: 226.2,
    cy: 180.9,
    r: 141.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g40",
    cx: 158.6,
    cy: 147.8,
    r: 296.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5010dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g41",
    cx: 240.1,
    cy: 227.3,
    r: 57.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3919bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 241.3,
    y1: 211.8,
    x2: 264.1,
    y2: 211.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 243.4,
    y1: 212.9,
    x2: 261.9,
    y2: 212.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f1fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a92ffb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 243,
    y1: 212.9,
    x2: 261.5,
    y2: 212.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f1fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a92ffb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 243.4,
    y1: 212.9,
    x2: 266.8,
    y2: 212.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#740df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8975b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g46",
    cx: 238.4,
    cy: 213,
    r: 48.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 251.2,
    y1: 223.2,
    x2: 254.4,
    y2: 223.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#740df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8975b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g48",
    cx: 217.2,
    cy: 213.7,
    r: 149.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g49",
    cx: 234.3,
    cy: 220.5,
    r: 203.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g50",
    cx: 182.6,
    cy: 153.1,
    r: 89.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 184.1,
    y1: 250.1,
    x2: 171,
    y2: 250.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbeff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g52",
    cx: 102.3,
    cy: 155.1,
    r: 116.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a92ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6507fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3919bb"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.4;fill:#172f78}.b{fill:#03a7d3}.c{opacity:.6;fill:#172f78}.d{fill:url(#g1)}.e{fill:url(#g2)}.f{fill:url(#g3)}.g{opacity:.6;fill:#020230}.h{fill:url(#g4)}.i{fill:#f0f6ff}.j{fill:#fcd1c5}.k{fill:url(#g5)}.l{fill:url(#g6)}.m{fill:#aa8383}.n{fill:#c4ccd6}.o{fill:url(#g7)}.p{fill:#e2b1a6}.q{fill:#936d6d}.r{fill:#24126a}.s{fill:url(#g8)}.t{fill:#0c0b6b}.u{fill:url(#g9)}.v{fill:url(#g10)}.w{fill:url(#g11)}.x{fill:url(#g12)}.y{fill:#515151}.z{fill:url(#g13)}.A{fill:#2d2d2d}.B{fill:url(#g14)}.C{fill:url(#g15)}.D{fill:url(#g16)}.E{fill:url(#g17)}.F{fill:#160a5b}.G{fill:url(#g18)}.H{fill:url(#g19)}.I{fill:#263649}.J{fill:#334659}.K{fill:url(#g20)}.L{fill:url(#g21)}.M{fill:#4326a2}.N{opacity:.5;fill:url(#g22)}.O{fill:url(#g23)}.P{fill:url(#g24)}.Q{opacity:.4;fill:#020230}.R{fill:url(#g25)}.S{opacity:.3;fill:#180d5b}.T{opacity:.6;fill:#2d2d2d}.U{fill:url(#g26)}.V{opacity:.5;fill:#000028}.W{fill:url(#g27)}.X{opacity:.4;fill:#06033e}.Y{fill:url(#g28)}.Z{fill:url(#g29)}.a0{fill:url(#g30)}.a1{fill:url(#g31)}.a2{fill:url(#g32)}.a3{fill:#fff}.a4{fill:#0c0a78}.a5{fill:url(#g33)}.a6{opacity:.5;fill:#fff}.a7{fill:url(#g34)}.a8{fill:url(#g35)}.a9{fill:url(#g36)}.aa{fill:url(#g37)}.ab{fill:url(#g38)}.ac{fill:url(#g39)}.ad{fill:url(#g40)}.ae{fill:#1e262d}.af{fill:url(#g41)}.ag{fill:url(#g42)}.ah{fill:url(#g43)}.ai{fill:url(#g44)}.aj{fill:url(#g45)}.ak{fill:url(#g46)}.al{fill:url(#g47)}.am{fill:url(#g48)}.an{fill:url(#g49)}.ao{fill:url(#g50)}.ap{fill:url(#g51)}.aq{fill:url(#g52)}.ar{fill:#172f78}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m343.7 360.7c-67.6 39-177.2 39-244.8 0-67.6-39-67.6-102.3 0-141.3 67.6-39 177.2-39 244.8 0 67.6 39 67.6 102.3 0 141.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m297.2 333.9c-41.9 24.1-109.8 24.1-151.7-0.1-41.9-24.1-41.9-63.4 0-87.6 41.9-24.1 109.8-24.1 151.7 0 41.9 24.2 41.9 63.5 0 87.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m222.1 403.1c-50.7 0-101.5-11.1-140.1-33.4-37.5-21.7-58.1-50.5-58.1-81.1 0-30.7 20.6-59.5 58.1-81.1 77.3-44.6 202.9-44.6 280.2 0 37.5 21.6 58.1 50.4 58.1 81.1 0 30.6-20.6 59.4-58.1 81.1-38.6 22.3-89.4 33.4-140.1 33.4zm0-228.3c-50.6 0-101.2 11.1-139.7 33.4-37.2 21.5-57.7 50-57.7 80.4 0 30.3 20.5 58.9 57.7 80.4 77 44.5 202.4 44.5 279.4 0 37.2-21.5 57.7-50.1 57.7-80.4 0-30.4-20.5-58.9-57.7-80.4-38.5-22.3-89.1-33.4-139.7-33.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m222.1 440.7c-43.4 0-86.9-9.6-120-28.7-32.1-18.5-49.8-43.2-49.8-69.5 0-26.2 17.7-50.9 49.8-69.4 66.2-38.2 173.8-38.2 240 0 32.1 18.5 49.8 43.2 49.8 69.5 0 26.2-17.7 50.9-49.8 69.5-33.1 19-76.5 28.6-120 28.6zm0-195.5c-43.3 0-86.6 9.5-119.6 28.5-31.8 18.4-49.4 42.9-49.4 68.8 0 26 17.6 50.5 49.4 68.9 66 38 173.2 38 239.2 0 31.8-18.4 49.4-42.9 49.4-68.8 0-26-17.6-50.5-49.4-68.9-33-19-76.3-28.5-119.6-28.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m226.7 239.6c0 0 3.6 4.1-2.4 7.3-6 3.1-10.6 6.8-11.9 8.4-1.4 1.6-5.9 6.1-10.8 7-4.9 0.9-9.7 0.2-8.3-4.8 1.4-5 8.1-10.1 9.5-11 1.5-0.9 5-2.9 6.2-4.4 1.3-1.4 2.4-2.7 2.4-2.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m256.4 250.3c0 0 1 2.2 1.3 5.1 0.3 2.9 0.7 9.1 0.8 11 0.2 1.8 0.3 6.3-3 10.6-3.2 4.3-4.9 6-9.1 4.3-4.3-1.7-4.2-8.9-3.5-12.6 0.8-3.7 1.5-12 1.4-12.8-0.1-0.9 0.4-2.8 0.4-2.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m205.9 140.9c0 0 48.2 15.8 49.8 23 1.7 7.1 0.2 12.9-0.2 20-0.4 7.2 2.6 30.2 3.2 37.4 0.7 7.2-0.2 29.8-2.8 34.2-0.9 1.5-2.6 2.3-4.3 2.8-3.7 0.9-7.3-2-7.2-5.8 0.2-11.4-0.9-27.4-2.1-30.4-1.4-3.6-4.3-8.5-8.4-21.6-4-13-7.1-15-7.1-15 0 0-2.8 18.2-0.7 24.7 2 6.6 2.7 22.4 0.9 30.8-1.9 8.5-13.2 6.1-15 3.5-1.8-2.5-0.5-5.7-0.5-5.7-0.7-18.3-6.2-33.7-6.2-33.7-7.7-17.5-8.6-50.5-8.6-50.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m258.7 221.3c0.7 7.2-0.2 29.8-2.8 34.2-0.4 0.7-1 1.2-1.7 1.7 0.1-0.5 3-15.8 1.1-28.4-1.9-12.8-4-27.2-3.9-29.5 0.1-2.3-0.1-20.3-1.3-21.7-1.2-1.3-22.1-0.1-29.3-3.7-7.1-3.5-12.9-11.7-13.8-14.1 0 0-6.6 1.1-10.1 0.1-0.2-3.3-0.2-5.3-0.2-5.3l1-1.5c2.5-1.1 5.6-2.2 6.7-2.4 1.3-0.2 20 1.4 34.8 2.7 8.7 3.9 15.9 7.8 16.5 10.5 1.7 7.1 0.2 12.9-0.2 20-0.4 7.2 2.6 30.2 3.2 37.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m238.9 42.7c0 0 1-0.9 2.9 0.2 1.9 1.1 6.5 9.7 6.5 9.7l19.4 14.7-22.7 25.1c0 0 6.5 20.7 9.2 31.1 2.8 10.4 6.1 36.6 3.5 42.9-2.6 6.2-15.3 6.2-30.7 6.3-15.4 0.2-18.9-17.6-18.9-17.6 0 0 1.4 2.5-2.9 3.9-4.3 1.5-18.1-9-18.7-9.6-0.5-0.7 5.7-25.2 5.7-25.2l5-25.8c0 0 0.7-9.9-1.7-24.5-1.9-11.9 0.7-20.1 1.7-22.7 0.2-0.6 0.7-1 1.3-1.2 3.6-0.8 14.3-3.3 14.3-3.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m241.4 42.7c0 0 3.9 4.7-1.7 11.2-3.5 4-9.6 12.5-14.7 21.4-3.2 5.6-6.1 8.5-7.8 13.3 0 0-0.3-5.7-0.5-14.4-0.2-8.3-0.3-16.9 0.1-19 0.7-4.5 20.2-14.7 24.6-12.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m226.6 57c0 0-2 1.3-2.7 1.2-0.7-0.1-2.9-2.3-2.9-2.3 0 0-5.6-0.1-6.3-2.5-0.6-2.4-1-4.8-1.5-6.1-0.6-1.2-3-7.2-3-9.6-0.1-2.5 0-6.8-1-9.1-1.1-2.3-2.5-25.3 19.7-24.7 22.3 0.7 15.4 23.8 15.4 23.8 0 0 1.6 0.6 0.6 3.6-1 3-1.2 3.3-1.7 4.8-0.5 1.4-0.8 2.4-2.2 3.6l-0.3 2.7c0 0 1 4.2-1.7 8.3-2.8 4-12.4 6.3-12.4 6.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m195.8 70.3c2 7.3 1.5 25.2 1.7 26.9 0.2 1.7-3.2 8.1-3.2 8.1 3 1.5 6.3 5.5 6.3 5.5l17.2 6.6-2.4 13.3c-0.1 0.5-0.6 0.8-1.1 0.7-8.7-3.3-36.3-13.6-37.8-14.2-1.6-0.6-2.4-9.2-1-17.2 1.4-8 8-19.2 12.3-30 7.7-19.4 10.1-19.7 10.1-19.7 0 0-4.1 12.7-2.1 20z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m201.4 110.8l-0.9-0.2c-0.7-1.6-6.4-5.2-6.4-5.2-0.2-1.5 1.8-5.5 2.6-6.8 0.1-0.3 0.4-0.5 0.7-0.5 1-0.1 2.8-0.3 3.2-0.1 0.6 0.3 3.8 1.4 4.4 1.6 0.6 0.2 2.9 1.8 2.9 1.8-2.7 1.2-6.5 9.4-6.5 9.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m256.9 137.9c-2.6 1.5-6.3 3.3-11.2 3.5-18.3 0.9-28.6-11.9-28.6-11.9l34.7-14.9c0.9 3.3 1.8 6.4 2.4 8.9 1 3.5 1.9 8.7 2.7 14.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m269.4 88.4c-1.6 8.1-16.8 47.2-28.7 47.3-11.9 0.2-42.7-14.2-42.7-14.2 0 0-0.4 0 1.1-7.2 1.9-9.1 8.8-12.9 8.8-12.9 2.2 1.6 13.8 6.9 21.6 10.4 3.7 1.6 7.9-0.7 8.6-4.7l0.2-1.5c0 0 5.4-13.6 12.8-25.3 7.4-11.7 16.6-13 16.6-13 5.2 2.3 3.4 13 1.7 21.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m229.2 111.6c0 0 1.1-1 2.4-2.1 1.4-1.2 3.7-6 4-6.5 0.4-0.4 5.1-3.9 7.3-4 2.2-0.1 0.6 2.4 0.1 2.8-0.6 0.3-2.7 1.4-2.7 1.4 0 0-2.3 1.9-2.5 2.2-0.3 0.3 6.2-0.4 7.2 0.2 1.1 0.6 0.8 2.3 0.1 2.7-0.7 0.5-1.3 0.5-1.3 0.5 0 0 0.8 1.9-1.2 2.9-2 0.9-2.4 0.4-2.4 0.4 0 0-0.2 3.3-3.4 2.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m227.5 0.8c14.3 1.3 17.6 8.8 18.5 16.1 0.8 7.3-1.7 10.8-1.7 10.8-3.8-1.8-5.6 2.7-5.6 2.7l-0.6 3.4c-0.1 0.5-0.6 0.9-1.2 0.9h-0.5c-0.6-0.1-1.1-0.5-1.1-1.1l-0.2-2.3q0-0.7-0.4-1.2l-2.3-3.3c-0.3-0.5-0.5-1.1-0.4-1.7 0.1-1.8 0.2-5.7-1.6-7-2.4-1.7-9.3 2.7-17 5.3-7.6 2.7-4.7-6.6-4.7-6.6 0 0 4.5-17.2 18.8-16z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m230.6 65.2l-2.2-1.7c0 0-2 1.7-2.7 3.4-0.8 1.7 0 7.3 0 7.3l-0.7 1.1-0.8-1.4-0.7-6.6c0 0 0.8-4.9 0.8-5 0.1-0.1 4.2 0.4 4.2 0.4 0 0 1.4 1.1 2.1 2.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m219.7 59.8c-0.4 0-2.8-0.2-2.8-0.2 1.1-0.8 3.4-1 3.4-1 0 0-0.2 1.3-0.6 1.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m224.2 67.3c0.6 1.3 0.8 8 0.8 8-1.5 2.9-8.2 16.8-8.2 16.8l-0.1-18.4c0 0 0.8-1.5 1.6-2.8 0.6-1 1.2-3.3 1.4-4.1q-0.1-0.1-0.1-0.2c-0.4-1.5 0-5.3-0.5-7-0.5-1.7 5.5-0.4 5.5-0.4l3.9 3.5c0 0-3.4 1.6-4.3 4.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m241 39.7l-0.3 2.7c0 0 1 4.2-1.7 8.3-2.8 4-12.4 6.3-12.4 6.3 0 0-2 1.3-2.7 1.2-0.7-0.1-2.9-2.3-2.9-2.3 0 0 12.5-3.8 17-16.7 0 0 1 1.1 3 0.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m247.7 62.2l-4.3-0.8 2.5 3.7c-17.6 18.5-27.6 33.9-27.6 33.9 4.4-12.2 25.5-34.8 25.5-34.8l-2.1-3.9c0 0 4.2 0.5 4.5 0.3 0.2-0.2 1.9-6.3 1.9-6.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m213.5 48.9l-1.1 1.3 1.3 1.2-3.9 3.6c0 0-1.2 24.7 3.6 41.1 0 0-6.5-15-5-41.8l4.2-2.9-1.4-1.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m226.1 210.2c2 6.6 2.7 22.4 0.9 30.8-0.6 2.4-1.8 3.9-3.4 4.8 0-0.1 2.5-12.9 1.3-21.9-1.2-9.1-4.4-16.8-4.1-20.5 0.3-3.7 3.2-20 0.7-23.6l5.4 5.8q-0.1-0.1-0.1-0.1c0 0-2.8 18.2-0.7 24.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m236.4 34.7c-0.6-0.1-1.1-0.5-1.1-1.1l-0.2-2.3q0-0.7-0.4-1.2l-2.3-3.3c0 0 9.4-2.9 13.6-9.3 0.7 6.9-1.7 10.2-1.7 10.2-3.8-1.8-5.6 2.7-5.6 2.7l-0.6 3.4c-0.1 0.5-0.6 0.9-1.2 0.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m238.5 319.3c0 2.9-2.3 5.3-5.2 5.3-2.9 0-5.2-2.4-5.2-5.3 0-2.9 2.3-5.2 5.2-5.2 2.9 0 5.2 2.3 5.2 5.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m290.1 260.8c0 2.9-2.4 5.3-5.2 5.3-2.9 0-5.3-2.4-5.3-5.3 0-2.8 2.4-5.2 5.3-5.2 2.8 0 5.2 2.4 5.2 5.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m301.3 300.8c0 2.9-2.3 5.2-5.2 5.2-2.9 0-5.2-2.3-5.2-5.2 0-2.9 2.3-5.2 5.2-5.2 2.9 0 5.2 2.3 5.2 5.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m188.3 290.9c0 2.9-2.4 5.3-5.3 5.3-2.9 0-5.2-2.4-5.2-5.3 0-2.8 2.3-5.2 5.2-5.2 2.9 0 5.3 2.4 5.3 5.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m220.6 255.6c0 2.9-2.3 5.2-5.2 5.2-2.9 0-5.2-2.3-5.2-5.2 0-2.9 2.3-5.2 5.2-5.2 2.9 0 5.2 2.3 5.2 5.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m242 279.6l-57.5 11.1c-2.2 0.2-4.3-0.7-4.7-2q0-0.2 0-0.4v-3.2l2.8 0.7-0.1 0.4q0.3-0.1 0.7-0.1l57.5-11.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m288.9 258.5c0 0.7-0.4 1.4-1.4 1.9l-41 17.9-5.7-3.4 41-17.8c1.6-0.9 3.9-1 5.4-0.4l1.7-1.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m245.7 275.4l-7.2 2.1-26.5-24.1q-0.4-0.5-0.4-1v-3.3c0 0 0.8 0.5 1.2 0.9q0.2 0.2 0.4 0.5 0.3-0.2 0.6-0.3c2-0.6 4.5-0.1 5.5 1.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m299.9 298.6q0 0.5-0.5 1.1c-1 1.1-3.4 1.6-5.4 1l-51.9-21.1 3.7-4.2 51.9 21.1q0.3 0.1 0.7 0.3l0.5-1.2 1-0.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m246.5 278.3l-9.1 39c-0.4 1.3-2.4 2.2-4.6 2-2-0.2-3.3-1.1-3.4-2.2h-0.1v-3.3l0.7 0.3 8.5-36.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "v",
    d: "m299.4 296.4c-1 1.2-3.4 1.6-5.4 1l-48.1-19.5-8.5 36.2c-0.4 1.3-2.4 2.1-4.6 1.9-2.3-0.2-3.8-1.4-3.4-2.6l8.4-36.3-53.3 10.3c-2.2 0.2-4.3-0.6-4.7-1.9-0.3-1.3 1.2-2.5 3.4-2.7l53.4-10.3-24.6-22.4c-1-1.1-0.2-2.5 1.8-3.1 2-0.6 4.5-0.2 5.5 1l24.5 22.4 38-16.5c1.7-1 4.3-1.1 5.7-0.3l0.4 0.3c1.5 0.8 1.3 2.3-0.4 3.3l-38 16.5 48.2 19.6c2 0.6 2.8 2 1.7 3.1zm-56.4-23.4l-1.8 0.5 0.3 1.1 2 0.2 0.9-1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m242.7 276.8c-2.3 0-4.2-1.9-4.2-4.2v-48.6h8.4v48.6c0 2.3-1.9 4.2-4.2 4.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m220.4 171.3c-0.1 1.3-1.2 2.7-3.1 3.9l-26.6 15.3c-3.7 2.1-9.4 2.4-12.7 0.5l-0.9-0.5c-1.4-0.9-2.1-2-2.1-3.2h-0.1v-4.6h0.1c0-1.4 1.1-2.9 3.1-4.1l26.5-15.3c3.8-2.1 9.5-2.4 12.7-0.5l0.9 0.5c1.4 0.8 2.1 1.8 2.2 2.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m178 186.5l-0.9-0.5c-3.2-1.9-2.8-5.2 1-7.4l26.5-15.3c3.8-2.1 9.5-2.4 12.7-0.5l0.9 0.5c3.2 1.9 2.8 5.2-0.9 7.4l-26.6 15.3c-3.7 2.1-9.4 2.4-12.7 0.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m234.2 207.9l-55.6 32c-2.7 1.6-5-0.1-5-3.7 0-3.7 2.3-8 5-9.6l63.7-36.7v2.5c0 6-3.6 12.9-8.1 15.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m294.3 102.6l-11.5 128.6-18.5 15.8-32.6 25.1-56.5-32 40.2-27 17.7-14.4v-3.5l-14.7 8.5v-109.9c0-8.2 5-17.7 11.1-21.3l1.7-0.9c2.7-1.6 5.2-1.7 7.1-0.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m191.7 249.4l-1.8-2.5c0 0-9.5-2.3-9.9-2.9-0.5-0.5 14-13.5 14.4-14 0.4-0.5 32.1-3.6 32.1-3.6l-1.7 3.9c0 0-5.6 4.1-6.7 4.8-1.2 0.7-16.8 7.3-19.8 10.3-2.9 3-1.4 6.9-1.4 6.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m298.6 111.8v109.9 2.5c0 6-3.6 12.9-8.1 15.5l-55.6 32c-2.7 1.6-5-0.1-5-3.7 0-3.7 2.3-8 5-9.6l39.8-22.9v-109.9c0-8.2 5-17.7 11.1-21.2l1.7-1c6.1-3.5 11.1 0.2 11.1 8.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m197.7 266.7c1.9-0.9 5.3 3.2 6.1 5.6 0.9 2.3-1 6.3-8 10.1-7 3.7-4.7 4.2-12.9 11.7-8.1 7.6-15.8 5.9-18 2.8-2.3-3 3.2-9.3 6-12.4 2.7-3.1 10.9-8.4 10.9-8.4 0 0 14-8.5 15.9-9.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m238.7 286.2c0 0 0.4 0.7 2 4.5 1.7 3.8-1.8 10.5-3.2 13-1.4 2.5-2.7 10.1-8.5 16.3-5.7 6.2-13 7-16.8 4.2-3.9-2.9 3.5-15.2 5-17.4 1.5-2.1 4.5-8.6 4.5-8.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m266.5 225.9c-3 4-34.5 40.3-34.5 40.3 2.7 5 8.5 19.7 6.6 27.3-1.8 7.6-13.5 6.4-16 5.4-2.5-0.9-5.3-10.5-8.3-15-2.9-4.6-4.7-7-7.9-15-3.1-7.9 6.3-19.3 12-26.4 5.6-7.1 7-14.3 7-14.3 0 0-4.1 2.1-11.8 4.8-7.7 2.7-23.3 13.4-23.3 13.4 0 0 7.1 14.8 9.8 19.4 2.6 4.6-1.7 11.6-1.7 11.6-9.6 7.2-17.1-1.8-17.1-1.8 0 0-10-16.7-14.7-21.8-4.7-5.1-3-11.6-3-11.6 4-12.1 28.3-36.1 28.3-36.1 9.8-6.2 77.6 15.8 74.6 19.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m198.4 277.4c0 0-0.8-7.6-7.2-19.1-6.4-11.5-7.7-12.3-7.7-12.3 0 0 23.9-19.6 27.7-22.4 3.8-2.8 4.7-4.1 4.7-4.1 0 0-5.4 1.1-7.6 0.1-2.2-1.1-5.6-9.3-5.6-9.3 0 0-9.1 0.1-10.8-4.2 4.9-3.1 24.1 0.9 41.9 6.1-2.2 6.1-6.9 13.9-8.4 16 0 0-4.1 2.1-11.8 4.8-7.7 2.7-23.3 13.4-23.3 13.4 0 0 7.1 14.8 9.8 19.4 2.6 4.6-1.7 11.6-1.7 11.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m266.5 225.9c-3 4-34.5 40.3-34.5 40.3 2.7 5 8.5 19.7 6.6 27.3-0.5 2.2-1.9 3.7-3.6 4.6 0 0 0.5-15.9-4-24.7-4.5-8.7-4.5-8.7-4.5-8.7 0 0 19.3-22.2 19.4-26.8 0 0-12.6-0.6-18.8-13.1-3.7-7.4 12.7-7.3 26.8-6 8.1 3.2 13.5 5.9 12.6 7.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m167.3 142.1l3.8-2.9c0 0 20.1-11.2 26.9-14.8 3.6-2 7.4-5.5 10.1-8.3 2.6-2.7 6.2-4.3 10-4.3l35.4-0.2c0 0 4.1 6.6 5.5 7.9 1 1 10.6 9 17.4 15.6 3.9 3.7 6.6 8.3 8.1 13.4 3.9 13.8 3.8 41.8 4.4 61.8 0 0-2.4 1-8.4 2.3-6.1 1.2-5.3 0.4-5.3 0.4 0 0-9 20.3-21.3 22.3-12.2 1.9-28.7-3.8-31.6-23 0 0-23.9-3.6-30.3-6.2-0.6-0.3-0.8-1-0.5-1.5 2.9-3.9 13.7-18.7 14.7-28.4 1.2-11.1 0.8-27.4-0.1-31.8 0 0-17.9 6.8-23.7 8 0 0-21.9 24-31 30.6 0 0 3.1-4.9-3.2-8.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m275.2 213.1c-0.3 0.5-2.4 5-5.7 9.8-0.1 0-29.6-4.3-33.4-3.5-3.8 0.8-12-0.4-12.1-0.4q-1-2.6-1.5-5.7l6.6-6.3 19.4-1 33.2 3.5 1.2 2.5q-1.1 0.3-2.4 0.6c-5 1-5.4 0.6-5.3 0.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m238.7 211.1c0 0.2-0.1 0.4-0.3 0.4l-6.5 0.6q-0.1 0-0.1 0c-0.6 0.3-7.1 3.3-11.7 2.9-3.8-0.4-6.5 0-7.6 0.1-0.1 0.1-0.2 0.2-0.2 0.4 0.2 0.6-0.2 2-0.6 2.1-0.6 0.2-2.8-0.3-3.3-0.3-0.3-0.1-1.1-1.7-1.5-2.6q-0.3-0.5-0.6-1c-0.5-0.6-1.5-2.5-1.5-2.5l-0.7-0.1c0 0-0.5-0.9-1.4-2.3-0.9-1.4-0.3-5.1 0.1-6.2 0.4-1.2 7.5-4.2 7.7-4.5 0.3-0.2 4.8-0.5 9 1 3.9 1.3 14.3 1.6 15.9 1.7q0.2 0 0.3 0.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m231.4 123.9c0 0 19.2-11.9 21.4-9.6 2.1 2.3 1.3 6.9-1 13.3-2.3 6.5-23.6 46.2-23.6 46.2-5.9-21-0.4-41.4-0.4-41.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m230.9 168.6l-1.1-2.6 3.2-17.6 0.6-7.5c0 0 3.2-4.4 4.5-3.8 1.2 0.5 2.2 2.1 2.2 2.1 2-0.7 8.5-5.1 8.5-5.1-0.5 1.1-8.6 7-8.6 7l-1.6-3.3-3.6 3.3c0 0 1 2.9 1.7 6.9 0.7 4-3.4 16.4-3.4 16.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m234.4 140.9c0.6 1.9 1.3 6.5-0.2 12.1-2.1 7.7-2.9 14.9-2.9 14.9l-3.1 5.9c0 0-4-11.6-2.7-23.3 0.5-4.1 3.1-7.9 4.1-9.3-0.6-0.7 0.2-8.5 0.2-8.5 4.7-2 8.3 4.4 8.3 4.4 0 0-2.3 2.7-3.7 3.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m242.2 79.7c18.9 1.5 12.8 25.7 12.8 25.7 1.3 2-1.3 6.6-1.6 7.6-0.4 1.1-1.5 2.6-1.5 2.6v1.2c0.5 11.1-15.3 15.6-15.3 15.6l-3.1-1.3c0 0-1.4 1.1-2.7 1.4-1.4 0.4-4 0.1-6.1-1.6-2-1.7-2.2-6.7-2.7-7.7-0.6-0.9-1.3-0.9-1.9-1.6-0.6-0.6-0.1-2.6-0.1-2.6-0.6-2-1.7-7.8-1.4-9.7 0.3-1.9-1-2.5-1.3-3.5-0.4-0.9 0.6-5.9 0.6-5.9 2.5-8.4 5.4-21.7 24.3-20.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m236.6 132.4l-3.1-1.3c0 0 12-6.9 13.1-12.7 1.1-5.7 1.5-6.5 1.5-6.5 0 0-0.5 4.5 1.6 4.1 0.7-0.1 1.4 0.2 2.2 0.7v0.1c0.5 11.1-15.3 15.6-15.3 15.6z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m227.1 79.4c2.3-1.4 1.7-1.2 5.7-2.7 3-1.1 16.9-1.8 22.1 8 5.1 9.9 0.1 20.7 0.1 20.7-6.2-0.4-6.6 7-6.6 7l-0.7 0.3c-1 0.3-2-0.3-2.2-1.2l-0.5-3.4-2.9-1.2c-0.8-0.4-1.4-1.2-1.3-2.1l0.1-3.4c0-1.1-0.7-2.1-1.7-2.5-2.3-0.8-6.5-1.6-10.7 0.3-6.1 2.9-9.4 2-9.4 2-3.9-3.2-3-7.9-1.1-11.8 2-4.2 5.2-7.6 9.1-10z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m271.5 196.3l-16.5 1.1 9.3-4.9c1.2-6 4-27.1 4-27.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m248.4 112.4l-0.7 0.3c-1 0.3-2-0.3-2.2-1.2l-0.5-3.4-2.9-1.2c-0.8-0.4-1.4-1.2-1.3-2.1l0.1-3.4c0 0 8.5 1.4 16.2-4.7-0.4 5-2.1 8.7-2.1 8.7-6.2-0.4-6.6 7-6.6 7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m254.9 145.5l-3.6-0.4 1 4.7-23.6 27.1 21.2-28-0.7-5.3 3.9 0.4c1.1-3.2 6-20.1 6-20.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m237.3 212.4c0 0 47.4-1.3 49-3.5 1.6-2.1 3.4-44.9-0.1-57.1 4.5 14.3 4.4 34.7 4.5 39.9 0.1 7.5-0.1 20.3-1.4 21.2-1.3 0.9-51.1 2.5-51.1 2.5 0 0-0.4-1.2-0.9-3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m141.4 174l2.6-1.7 7.5 2.3c0 0 2 6.1 1.4 6.9-0.7 0.8-2.4 2.4-2.8 4.8-0.3 2.5-3 7.9-4.5 8.4-1.4 0.4-3.8 3.8-4.9 4.7-1.1 0.8-2.2 5.1-3.9 2.4-1.7-2.8 2.3-6.7 2.9-7.1 0.6-0.3 1.8-2.5 0.5-2.9-1.2-0.4-8.8 5.7-10.7 7.2-1.9 1.4-4.4 2.7-4.4 2.7-0.1 0.2-1 2-2.7 1.4-1.7-0.6-0.2-2.9-0.2-2.9l1.3-5.9c0 0-0.4-1.8-0.4-2.1 0-0.2 1.2-4.2 1.3-4.6 0.1-0.5 4.1-4 5-4.8 0.9-0.8 6.4-3.5 8.6-4.7 2.2-1.3 2.4-2.5 2.4-2.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m290.7 191.7c0.1 7.5-0.1 20.3-1.4 21.2-1.3 0.9-51.1 2.5-51.1 2.5 0 0-4.8-15.4-2.7-15.3 2.2 0.1 33.4-5 33.4-5-1.1-3.5-2.3-28 1-37.8 1.9-5.4 5.4-9.7 8.2-12.5 2.2-2 2.9-3.8 4.4-1.3 8.2 12.8 8.1 41.9 8.2 48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m237.3 212.4c0 0 47.4-1.3 49-3.5 1.6-2.1 3.4-44.9-0.1-57.1 4.5 14.3 4.4 34.7 4.5 39.9 0.1 7.5-0.1 20.3-1.4 21.2-1.3 0.9-51.1 2.5-51.1 2.5 0 0-0.4-1.2-0.9-3z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m296.5 215c-0.1 1.3-1.2 2.8-3.1 3.9l-26.5 15.3c-3.8 2.2-9.5 2.4-12.7 0.5l-0.9-0.5c-1.5-0.8-2.2-2-2.2-3.2v-4.6c0-1.4 1.1-2.9 3.1-4l26.5-15.4c3.8-2.1 9.5-2.4 12.7-0.5l0.9 0.5c1.4 0.8 2.1 1.8 2.2 2.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m254.2 230.2l-0.9-0.5c-3.3-1.9-2.9-5.2 0.9-7.3l26.5-15.4c3.8-2.1 9.5-2.4 12.7-0.5l0.9 0.5c3.3 1.9 2.9 5.2-0.9 7.4l-26.5 15.3c-3.8 2.2-9.5 2.4-12.7 0.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m206.2 360.9q-1.6 0-3-0.8c-2.1-1.2-3.2-3.6-3.2-6.8v-71.6h3.1v71.6c0 2 0.6 3.5 1.7 4.1 1 0.6 2.6 0.4 4.4-0.6l59.5-34.4c4.2-2.4 7.7-8.5 7.7-13.3v-71.5h3.1v71.5c0 6-4 13-9.2 16l-59.6 34.4c-1.5 0.9-3.1 1.4-4.5 1.4z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m54 276.2q-1.6 0-3-0.8c-2.1-1.2-3.2-3.6-3.2-6.8v-71.6h3.1v71.6c0 2 0.6 3.5 1.7 4.1 1 0.6 2.6 0.4 4.4-0.6l59.6-34.4c4.1-2.4 7.6-8.5 7.6-13.3v-71.5h3.1v71.5c0 6-4 13-9.2 16l-59.6 34.4c-1.5 0.9-3.1 1.4-4.5 1.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m200.7 311.6l-152.1-86.3 1.5-2.7 152.2 86.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m201.9 297.5l-162.3-93.8 87.2-50.3 162.3 93.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m201.9 289.7l87.2-50.3v7.8l-87.2 50.3-162.3-93.8v-7.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m201.9 289.7l-162.3-93.7 87.2-50.4 162.3 93.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m210.9 213.3l7.7-2.8 19.9-1.3 8.1 5.6 3.6 2.1c0 0-23 0.4-27.7 1.2-4.8 0.8-11-1.4-11-1.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m238.7 211.1c0 0.2-0.1 0.4-0.3 0.4l-6.5 0.6q-0.1 0-0.1 0c-0.6 0.3-7.1 3.3-11.7 2.9-3.8-0.4-6.5 0-7.6 0.1-0.1 0.1-0.2 0.2-0.2 0.4 0.2 0.6-0.2 2-0.6 2.1-0.6 0.2-2.8-0.3-3.3-0.3-0.3-0.1-1.1-1.7-1.5-2.6q-0.3-0.5-0.6-1c-0.5-0.6-1.5-2.5-1.5-2.5l-0.7-0.1c0 0-0.5-0.9-1.4-2.3-0.9-1.4-0.3-5.1 0.1-6.2 0.4-1.2 7.5-4.2 7.7-4.5 0.3-0.2 4.8-0.5 9 1 3.9 1.3 14.3 1.6 15.9 1.7q0.2 0 0.3 0.2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m290.7 191.7c0.1 7.5-0.1 20.3-1.4 21.2-1.3 0.9-51.1 2.5-51.1 2.5 0 0-4.8-15.4-2.7-15.3 2.2 0.1 33.4-5 33.4-5-1.1-3.5-2.3-28 1-37.8 1.9-5.4 5.4-9.7 8.2-12.5 2.2-2 2.9-3.8 4.4-1.3 8.2 12.8 8.1 41.9 8.2 48.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m237.3 212.4c0 0 47.4-1.3 49-3.5 1.6-2.1 3.4-44.9-0.1-57.1 4.5 14.3 4.4 34.7 4.5 39.9 0.1 7.5-0.1 20.3-1.4 21.2-1.3 0.9-51.1 2.5-51.1 2.5 0 0-0.4-1.2-0.9-3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m142.6 194.5c-1.8 1.2-18 8.1-18 8.1v-3.2l19.6-13.8 12.7-12.6 10.1-4.2 5.9 3.5c0 0-1.1 1-3.6 2.3-2.6 1.4-20.4 15.3-20.4 15.3 0 0-4.5 3.5-6.3 4.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m139.3 198.8c0 0-2.8 0.6-4.6 0.8-1.7 0.2-5.4 2.6-7.4 3.2-2 0.7-2.9-0.4-2.9-0.4l15.6-9.1 9.4-5.4 6.5-3.7c0 0-4 5.1-4.5 7.4-0.5 2.3-4.4 5.3-6.8 6.4-2.5 1.1-6.3 4.5-6.3 4.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m141.4 174l2.6-1.7 7.5 2.3c0 0 2 6.1 1.4 6.9-0.7 0.8-2.4 2.4-2.8 4.8-0.3 2.5-3 7.9-4.5 8.4-1.4 0.4-3.8 3.8-4.9 4.7-1.1 0.8-2.2 5.1-3.9 2.4-1.7-2.8 2.3-6.7 2.9-7.1 0.6-0.3 1.8-2.5 0.5-2.9-1.2-0.4-8.8 5.7-10.7 7.2-1.9 1.4-4.4 2.7-4.4 2.7-0.1 0.2-1 2-2.7 1.4-1.7-0.6-0.2-2.9-0.2-2.9l1.3-5.9c0 0-0.4-1.8-0.4-2.1 0-0.2 1.2-4.2 1.3-4.6 0.1-0.5 4.1-4 5-4.8 0.9-0.8 6.4-3.5 8.6-4.7 2.2-1.3 2.4-2.5 2.4-2.5z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m205.9 144.5c-2 0.7-18.1 6.8-23.5 7.9 0 0-21.7 24.1-30.9 30.7 0 0 3-5-3.3-8.4-4.5-2.4-6.9-0.4-7.8 0.9 1.9-4 15.1-24.2 26.9-33.5l3.8-2.9c0 0 20.1-11.2 26.9-14.8 3.6-2 7.4-5.5 10.1-8.3q0.7-0.7 1.4-1.3c-1.9 8.5-1.6 19.7-1.6 19.7 0.1 3.3-0.7 6.6-2 10z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m110.6 214.2l38.9-22.5c0.7-0.4 1.7-0.3 2.5 0.1l65.2 37.6c0.7 0.5 0.8 1.1 0.1 1.4l-38.9 22.5c-0.6 0.4-1.7 0.3-2.4-0.1l-65.2-37.6c-0.7-0.5-0.8-1.1-0.2-1.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m92.6 189.4l25.8 4.7-10.4 15.6-20.4-9.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m95.4 195.3c0 1.3-0.9 2.6-2.6 3.6-3.4 1.9-8.9 1.9-12.3 0-1.8-1-2.6-2.3-2.6-3.6l-2-23.3h21.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m97 176.6l-1.6 18.7c0 1.3-0.9 2.6-2.6 3.6-1.4 0.8-3.3 1.3-5.2 1.4 2.6-0.5 4-1.5 4.7-2.3 0.4-0.6 0.7-1.3 0.7-2l0.7-17.1c-4.6 2-11.4 1.5-15.5-1.3q-1.2-0.8-2-1.8l-0.3-3.8h21.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m94.3 176.4c-4.2 2.4-11.1 2.4-15.3 0-4.2-2.4-4.2-6.4 0-8.8 4.2-2.4 11.1-2.4 15.3 0 4.2 2.4 4.2 6.4 0 8.8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m93.2 173.6c-3.6 2.1-9.5 2.1-13.1 0-3.6-2.1-3.6-5.5 0-7.6 3.6-2.1 9.5-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m94.7 176.7c-4.4 2.5-11.7 2.5-16.1 0-2.4-1.4-3.5-3.2-3.4-5q0.1-0.1 0.1-0.1l0.2-1.9c0-1.6 1.1-3.2 3.2-4.5 4.4-2.5 11.5-2.5 15.9 0 2 1.3 3.1 2.8 3.2 4.4l0.2 2.1q0 0 0 0c0.2 1.8-0.9 3.6-3.3 5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "Z",
    d: "m93.2 173.6c-3.6 2.1-9.5 2.1-13.1 0-3.6-2.1-3.6-5.5 0-7.6 3.6-2.1 9.5-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m92.8 173.6c-3.7 2.1-9.5 2.1-13.1 0-3.7-2.1-3.7-5.5 0-7.6 3.6-2.1 9.4-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m80 173.5c-3.5-2.1-3.5-5.4 0.1-7.5 3.6-2.1 9.5-2.1 13.1 0q0.7 0.4 1.2 0.9 0 0-0.1-0.1c-3.6-2.1-9.5-2.1-13.1 0-3.2 1.8-3.6 4.6-1.2 6.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m77.4 170.3c-0.2-1.5 0.7-3.1 2.7-4.3 3.6-2.1 9.5-2.1 13.1 0 2 1.2 2.9 2.8 2.7 4.3-0.2-1.2-1.1-2.4-2.7-3.3-3.6-2.1-9.5-2.1-13.1 0-1.6 0.9-2.5 2.1-2.7 3.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a2",
    d: "m94.5 174.5c-4.4 2.5-11.5 2.4-15.8-0.2-4.4-2.5-4.4-6.7 0-9.1 4.5-2.5 11.6-2.5 15.9 0.1 4.4 2.6 4.4 6.7-0.1 9.2zm-1.3-8.5c-3.6-2.1-9.5-2.1-13.1 0-3.6 2.1-3.6 5.5 0 7.6 1.2 0.7 2.7 1.1 4.2 1.4l0.2-0.6c0-0.2 0.2-0.3 0.5-0.3h3.3c0.2 0 0.4 0.1 0.5 0.3l0.2 0.6c1.5-0.3 3-0.7 4.2-1.4 3.6-2.1 3.6-5.5 0-7.6z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m95.9 169.6c-0.1-1.3-1-2.6-2.7-3.6-3.6-2.1-9.5-2.1-13.1 0-1.7 1-2.6 2.3-2.7 3.6-0.1-1.4 0.8-2.9 2.7-4 3.6-2.1 9.5-2.1 13.1 0 1.9 1.1 2.8 2.6 2.7 4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m97.9 169.7c0.1 1.7-1 3.5-3.4 4.8-4.4 2.5-11.5 2.4-15.8-0.2-2.3-1.3-3.4-3-3.3-4.7 0.1 1.5 1.2 3.1 3.3 4.3 4.3 2.6 11.4 2.7 15.8 0.2 2.2-1.2 3.3-2.8 3.4-4.4z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m87.6 175.3h-1.9c-0.2 0-0.3-0.1-0.3-0.3 0-0.2 0.1-0.3 0.3-0.3h1.9c0.2 0 0.3 0.1 0.3 0.3 0 0.2-0.1 0.3-0.3 0.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m87.9 175q0 0.1 0 0.1c-0.1-0.1-0.1-0.2-0.3-0.2h-1.9c-0.2 0-0.3 0.1-0.3 0.2q0 0 0-0.1c0-0.2 0.1-0.3 0.3-0.3h1.9c0.2 0 0.3 0.1 0.3 0.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m86 175.1c0 0 2.8-1.2 2.8-4.7 0.1-2.9-0.5-2.2-3.3-8.2-2.8-6.1 0.2-10.6 0.2-10.6-1.9 5.6 2.8 7.7 5.2 14.6 2.5 6.9-3.5 8.9-3.5 8.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m87.9 152.6c0 0-0.6-4.2 3.2-8.3 0 0-3.4 7.6-2.3 11.4 0 0-0.9-2.4-0.9-3.1z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m353.9 325.2c0 0 1.7 3.6 1.3 5.9-0.5 2.3-6.2 10.4-7.8 14.9-1.7 4.5-10.2 11.1-14.9 11.1-4.8 0-9.2-1.9-6.9-7.2 2.3-5.3 4.2-7.3 6.1-9.7 1.9-2.5 5.6-9.4 6.1-12.3 0.5-2.8 16.1-2.7 16.1-2.7z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m330.5 303.4c0 0 0.8 4.7 0.1 6.4-0.7 1.7-2.2 3.2-6.4 4.4-4.2 1.3-8.2 1.7-15.1 5.9-7.1 4.1-16.6 5.9-19.5 1.3-2.9-4.5 7.1-11.4 10.7-13.2 3.7-1.8 9.4-2.7 12.4-5.4 3.1-2.8 3.6-2.1 3.6-2.1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m356.1 220.8c0 0-3.5 31.2-2.4 42.1 1 11 8 31.2 5.7 44.8-2.3 13.8-5 19.4-5 19.4 0 0-9.4 9.6-16.6 1 0 0 3-5.5 2.6-19.8-0.2-7.3-0.3-11.5-0.4-13.9-0.1-1.8-0.6-3.5-1.5-5-2.2-3.8-6.7-12-10.1-21.5 0 0 1.6 20.2 1.5 29.3q0 2.1 0.4 4.2c0.2 1.2 0.4 2.7 0.1 3.9-0.5 2.3-8.8 11.2-15.7 4.1 0 0-2.6-1.8-2-7.4 0.3-3.6-0.6-11.7-1.4-18.2-0.6-5.1-2.2-9.9-4.5-14.4-1.9-3.6-3.7-11-4.8-14.4-2.3-6.8-10.6-39.4-10.8-46.8-0.1-7.4 9-12.7 9-12.7 0 0 21 10.3 20.6 11.4-0.4 1.1 26.3 12.3 26.3 12.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m300.2 195.5c0 0 21 10.3 20.6 11.4-0.4 1.1 26.3 12.3 26.3 12.3l9 1.6c0 0-3.5 31.2-2.4 42.1 1 11 8 31.2 5.7 44.8-2.3 13.8-5 19.4-5 19.4 0 0-1.5 1.6-3.8 2.9 1.2-4 5.3-18.2 5.2-30.6-0.2-14.5-6.5-37.8-6.8-45.3-0.2-4-3.3-7.3-7.1-7.5-6-0.2-15-1.2-21.1-4.7 1.9 8.1 7.6 26 7.6 26 0 0 1.8 21.6 1.5 30.2q0 1.3 0.3 2.6c0.2 1.2 0.5 3.1 0.2 4.6-0.1 0.8-1.4 2.5-3.1 4-0.2-8.9-2-31.3-2.6-36.5-0.7-5.8-6.8-28.9-6.8-28.9-3.2-2.5-4.8-8.4-5.4-11.4-2.7-5.8-3.1-11.3-8.2-11.4-0.4 0-6.7 7.7-10.8 1.6-1.3-6.5-2.2-12-2.3-14.5-0.1-7.4 9-12.7 9-12.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m293.1 206.3l4.7-1.1c0 0 2.4 2.7-0.1 5.5-2.5 2.8-4.3 2.5-4.3 2.5l-1.1-3.9z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m309.2 108.2c0.8 1.2-5 19.8-5 19.8l-4.1 23.5 2.5 28.8c0 0 0.7 22.4-3 25.3-2.6 2-7.2 3.7-9.7 4.6-1 0.3-2-0.3-2.2-1.3-2.9-13.2-4.5-44.2-3.9-48.8 0.7-4.9 9.6-31 11.7-41.1 2.1-10 5.8-14.1 8.8-15.7 2.9-1.6 4.2-1.5 4.2-1.5 0 0-0.1 5.2 0.7 6.4z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m372.8 130.4c0 0 4 7.8-1.3 18.2-5.4 10.4-18.4 31.7-18.4 31.7 0 0 4.2 29.8 3.6 37.1-0.6 7.3-6.1 15.8-7.4 18.6-1.4 2.7-12.8 9.6-25.9 3-13-6.5-14.2-15.5-15.5-25.2-1.3-9.6-0.9-9.1-0.9-9.1 0 0-6.1 19.2-9.7 15.6-1.6-1.6-1.7-6.3-1.3-11.2 0.9-10.6 1.2-21.2 0.8-31.6q-0.1-0.6-0.1-1c0-3.3-0.6-33.9 0.3-42.1 0.9-8.1-0.3-21.2 4-26.5 3.5-4.4 7.5-6.1 7.5-6.1l6.1-0.3c0 0 35.5-2.9 38.6 1.6 3.1 4.6 4.2 7.5 4.2 7.5 0 0 10.7 11.2 15.4 19.8z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m344.6 98c0 0 1.5 0.8 2.1 2.5 0.6 1.7 2.4 6.3 3.3 7.5 0 0-15.7 14.9-21.6 22.5-5.9 7.7-7.7 14-7.7 14l-8.1-9.6 2.5-2.8 1.4-6.3 2.4-7.1 1.7-7 19.5-11.1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m329.1 118.2c0 0 3.1 2.1 4.2 5.1 0 0-3-2.1-3.9-2.3 0 0-2.3 2.2-2.7 3-0.5 0.9 0 8.9 0 8.9l-1.1 1.7-1.3 0.1c0 0-0.2-5.7-0.3-6-0.2-0.3-0.4-4.9-0.3-5.2 0.1-0.4 4.2-4.3 4.2-4.3l1.5-1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m320.8 116.5c0 0 2-1 3.3-0.7 1.3 0.3 4.8 2.1 5.3 2.8 0.6 0.6-0.1 1.5-2.1 3.1-2 1.5-2.2 2.4-2.2 2.4 0 0 1.1 6.6 0.5 10.5 0 0-4.2 7.4-5.1 11-0.9 3.6-4.6-11.5-4.6-11.5 0 0 1.3-4.9 1.9-6.1 0.6-1.2 2.9-7.7 2.3-8.9-0.6-1.1 0.7-2.6 0.7-2.6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m354.4 119l-4.2-0.8 1 4.8-0.7 0.3c-18.7 11.9-27.4 26.3-27.4 26.3l-0.5-1.5c7.4-13.4 26.8-26.4 26.8-26.4l-0.6-4.8 4.8 0.2 2.6-5.6z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m319.9 112.6l-4.5-4.6c0 0 0.3-7-1.3-7.9-1.6-0.8-0.6-3.2-0.6-3.2-0.6-4.2 0.1-7.7 0.3-9.2 0-0.7-0.2-1.6-0.4-2.5-0.5-1.6-0.5-3.3 0-4.9 0.8-2.5 1.8-5.8 1.8-5.8 3.9-12.5 12.7-16.2 24.8-12.4 12.1 3.8 8.1 25.8 8.1 25.8 0.4 1.2-0.3 2.9-0.7 3.7-0.3 0.8-1.4 3.5-1.6 4.7-0.1 1.2-1.1 1.9-1.1 1.9 0.1 0.7 0.9 4.5 0.9 4.5-2 7.9-15.5 13.2-18 13-2.5-0.2-3.4-2.7-3.4-2.7-3.4 0.6-4.3-0.4-4.3-0.4z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m343.2 87.2c-1.9 1.3-3.2 3.4-3.5 5.7 0 0.2-0.8 0.4-1.5 0.2-0.4-0.2-0.7-0.7-0.7-1.1v-0.7c0-0.5-0.1-0.9-0.3-1.2-0.2-0.4-0.5-1.2-0.5-3.3 0-3.8-1.5-5.4-4.3-5.3-2.9 0-9.2-1.9-14.1-3.7-4.9-1.7-3.4-4.8-3.4-4.8 4-14.2 17-17.7 28-11.5 13.9 8 5.3 27.6 5.3 27.6-0.4-4-2.8-3.3-5-1.9z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m317.8 128c0.6-1.2 2.9-7.7 2.3-8.9-0.6-1.1 0.7-2.6 0.7-2.6 0 0 2-1 3.3-0.7q0.2 0.1 0.5 0.2 0 0 0 0c0 0-1.7 3-2.1 3.8-0.4 0.7-1.9 8.4-2.8 10.1-0.8 1.7-2.5 7.7-2.5 7.7l-0.5-0.3c-0.5-1.8-0.8-3.2-0.8-3.2 0 0 1.3-4.9 1.9-6.1z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m319.1 108.4c0 0 2.1 3.2 2.3 4.7-1.1-0.1-1.5-0.5-1.5-0.5l-1.8-1.9c0.5-1.2 1-2.3 1-2.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m304.8 137.7c0 0-2.4-3.8-2.3-7 0.1-3.1 1-6.9 1-6.9 0 0-1.8 0.1-1.7-2.6 0.1-2.6 0.8-5.1 1.7-5.8 0.9-0.7 1.8-0.5 1.8-0.5 0 0 0.7-2.1 2.6-1.8 0 0 0.1-1.4 1.7-2.5 1.6-1.1 2.7 0.6 2.7 0.6 0 0 0.6-2.3 1.3-2.7 0.6-0.4 1.8-0.5 1.8-0.5 0 0 3.1-0.5 3.7 0.4 0.5 0.8 2 9.8 1.9 10.2-0.1 0.5-0.8 5.1-1.3 6.5-0.5 1.5-4.1 5.2-4.6 7-0.6 1.8-6.3 7.5-6.3 7.5-0.1 0-4-1.9-4-1.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m306.3 206.9c-0.9-24.4 3.4-42.6 3.4-42.6l2.7-4.5c-5.2 13.8-5.4 44.9-5.4 44.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m307.8 156c0 0 23.2 20.7 23.3 21 0.1 0.3 33.8-20.9 33.8-20.9l1.1 2.4c-5.9 10.2-12.9 21.8-12.9 21.8 0 0 0.5 3.6 1.1 8.6 0 0-16.7 17.8-27.1 15.5-8.9-1.9-18.5-31.7-20.9-39.7-0.4-1.3-0.4-2.7 0-3.9z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m303.4 134.6c3.4-2 9.4-2.6 9.4-2.6l-7 6.2c-0.6-0.3-1-0.5-1-0.5 0 0-0.8-1.3-1.5-3q0.1-0.1 0.1-0.1z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "m346.2 143.2c3.5-4.5 8.4-8 13.1-11.1 4.2-2.7 8.8-4.8 11.3-3.1 5.5 3.8 4.3 10.7 1.8 17.6-2.6 7-25.9 46.2-42.3 45.3 0 0-11.8-12.2-17.2-21.8-4.5-8-12-21.9-14.2-26-0.4-0.8-0.2-1.6 0.4-2.2 3.2-2.9 13-11.5 15.9-10 0 0 6.7 16.8 13.3 25.1l5.3 5c0 0 4.3-8 7.8-12.6 1.2-1.7 3.1-4 4.8-6.2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m327.6 115.7c-2.5-0.2-3.4-2.7-3.4-2.7 0 0 13.9-5.5 15.4-14 0 0 0.1 8.9-3.5 13.6-3.7 2-7.3 3.1-8.5 3.1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m339.7 92.9c0 0.2-0.8 0.4-1.5 0.2-0.4-0.2-0.7-0.7-0.7-1.1v-0.7c0-0.5-0.1-0.9-0.3-1.2-0.2-0.4-0.5-1.2-0.5-3.3 0-1.7-0.3-3-0.9-3.8 0 0 7.8 0.5 14.2 0.4-0.3 0.9-0.4 1.8-0.7 2.6-0.5 1.8-1.1 3.1-1.1 3.1-0.4-4-2.8-3.3-5-1.9-1.9 1.3-3.2 3.4-3.5 5.7z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m328.4 267.9q0 0 0 0.3 0-0.2 0-0.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m340.6 330.5q-1.4-0.8-2.8-2.4c0 0 3-5.5 2.6-19.8-0.2-7.3-0.3-11.5-0.4-13.9-0.1-1.8-0.6-3.5-1.5-5-2.1-3.6-6.3-11.2-9.6-20.1q0-0.1 0-0.2c2.3 4.2 13 16.9 14.4 26.6 1.3 9.5-1.7 28.8-2.7 34.8z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m328.9 269.1q0 0-0.1-0.1-0.2-0.5-0.4-1.1c0.1-0.2 0.2 0.2 0.5 1.2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m305.6 167.5c1 0.1 1.7 1.4 1.6 2.8-0.2 1.4-1.2 2.5-2.2 2.3-1.1-0.1-1.8-1.4-1.6-2.8 0.1-1.4 1.1-2.4 2.2-2.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m304 184.3c1.1 0 1.9 1.1 1.9 2.6 0 1.4-0.9 2.6-2 2.6-1.1-0.1-1.9-1.2-1.9-2.7 0-1.4 0.9-2.6 2-2.5z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m300.6 140.6c0 0 21.2 45.8 30.9 47.6 9.7 1.8 35.7-31.9 35.7-31.9q0 0.1 0 0.2c-8.4 13.8-24.8 36-37.1 35.4 0 0-11.8-12.2-17.2-21.8-4.5-8-12-21.9-14.2-26-0.4-0.8-0.2-1.6 0.4-2.2q0.6-0.5 1.5-1.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m334.1 161.1l3.1 7.9c-1-2.7-3.6-7-3.6-7z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m258.6 237.9l25.2 4.5-19.5 11.3-10.6-4.9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m261.4 243.8c0 1.2-0.8 2.5-2.5 3.5-3.5 2-9 2-12.4 0-1.7-1-2.6-2.3-2.6-3.5l-2-23.3h21.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m263 225.1l-1.6 18.7c0 1.2-0.8 2.5-2.5 3.5-1.5 0.9-3.3 1.3-5.2 1.5 2.5-0.6 3.9-1.5 4.6-2.4 0.5-0.5 0.7-1.2 0.7-2l0.8-17c-4.7 1.9-11.5 1.4-15.6-1.3q-1.2-0.9-2-1.8l-0.3-3.8h21.5z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m260.3 224.8c-4.2 2.5-11 2.5-15.2 0-4.2-2.4-4.2-6.3 0-8.7 4.2-2.5 11-2.5 15.2 0 4.2 2.4 4.2 6.3 0 8.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m259.2 222c-3.6 2.1-9.5 2.1-13.1 0-3.6-2-3.6-5.4 0-7.5 3.6-2.1 9.5-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.5z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m260.7 225.1c-4.4 2.6-11.6 2.6-16.1 0-2.3-1.3-3.4-3.1-3.3-4.9q0-0.1 0-0.2l0.2-1.8c0-1.7 1.1-3.3 3.3-4.5 4.3-2.5 11.4-2.5 15.8 0 2.1 1.2 3.2 2.8 3.2 4.3h0.1l0.2 2.1q0 0 0 0v0.1c0.1 1.7-1 3.5-3.4 4.9z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m259.2 222c-3.6 2.1-9.5 2.1-13.1 0-3.6-2-3.6-5.4 0-7.5 3.6-2.1 9.5-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.5z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m258.8 222c-3.6 2.1-9.5 2.1-13.1 0-3.6-2-3.6-5.4 0-7.5 3.6-2.1 9.5-2.1 13.1 0 3.6 2.1 3.6 5.5 0 7.5z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m246 222c-3.5-2.1-3.5-5.5 0.1-7.5 3.6-2.1 9.5-2.1 13.1 0q0.7 0.4 1.3 0.9-0.1-0.1-0.2-0.1c-3.6-2.1-9.5-2.1-13.1 0-3.1 1.8-3.5 4.6-1.2 6.7z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m243.4 218.7c-0.2-1.5 0.7-3.1 2.7-4.2 3.6-2.1 9.5-2.1 13.1 0 2 1.1 2.9 2.7 2.7 4.2-0.2-1.2-1.1-2.4-2.7-3.3-3.6-2.1-9.5-2.1-13.1 0-1.6 0.9-2.5 2.1-2.7 3.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ak",
    d: "m260.6 222.9c-4.4 2.5-11.5 2.4-15.9-0.1-4.4-2.6-4.3-6.7 0.1-9.2 4.4-2.5 11.5-2.4 15.8 0.1 4.4 2.6 4.4 6.7 0 9.2zm-1.4-8.4c-3.6-2.1-9.5-2.1-13.1 0-3.6 2.1-3.6 5.5 0 7.5 1.2 0.7 2.7 1.2 4.2 1.4l0.2-0.5c0.1-0.2 0.3-0.4 0.5-0.4h3.3c0.3 0 0.5 0.2 0.5 0.4l0.2 0.5c1.6-0.2 3-0.7 4.2-1.4 3.6-2 3.6-5.4 0-7.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m261.9 218.1c-0.1-1.3-1-2.6-2.7-3.6-3.6-2.1-9.5-2.1-13.1 0-1.7 1-2.6 2.3-2.7 3.6-0.1-1.5 0.8-2.9 2.7-4 3.6-2.1 9.5-2.1 13.1 0 1.9 1.1 2.8 2.5 2.7 4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m263.9 218.1c0.1 1.8-1 3.5-3.3 4.8-4.4 2.5-11.5 2.4-15.9-0.1-2.3-1.3-3.3-3.1-3.3-4.8 0.1 1.6 1.2 3.2 3.3 4.4 4.4 2.5 11.5 2.6 15.9 0.1 2.1-1.2 3.2-2.8 3.3-4.4z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m253.7 223.7h-2c-0.2 0-0.3-0.1-0.3-0.2v-0.1c0-0.1 0.1-0.2 0.3-0.2h2c0.1 0 0.2 0.1 0.2 0.2v0.1c0 0.1-0.1 0.2-0.2 0.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m253.9 223.4v0.1q0 0 0 0c0-0.1-0.1-0.1-0.2-0.1h-2c-0.1 0-0.2 0-0.3 0.1q0 0 0 0v-0.1c0-0.1 0.1-0.2 0.3-0.2h2c0.1 0 0.2 0.1 0.2 0.2z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m107.9 210.7l3.6 1.9 36-20.9c0.6-0.3 1.7-0.3 2.4 0.1l62.2 35.9c0.6-0.3 3.3-1.6 3.3-1.6l-1.3 3.4h-0.1q0 0.3-0.3 0.4l-38 22c-0.6 0.3-1.7 0.3-2.3-0.1l-63.7-36.8q-0.4-0.2-0.5-0.5z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m108.3 209.9l38.9-22.5c0.6-0.3 1.7-0.3 2.4 0.1l65.2 37.7c0.7 0.4 0.8 1 0.2 1.4l-38.9 22.4c-0.7 0.4-1.7 0.3-2.5-0.1l-65.2-37.6c-0.7-0.4-0.8-1.1-0.1-1.4z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m133.2 205l44.1 25.5-2.1 1.2-44.1-25.5z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m129.8 206.9l52 30-2.1 1.2-52-30z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m126.5 208.8l52 30-2.1 1.2-52-30z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m123.2 210.7l51.9 30.1-2.1 1.2-51.9-30z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m190.3 232l-2.1 1.2-2.1-1.2-49.9-28.8 2.1-1.2 50.3 29z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m174.7 228.9l10.5 6.1-2.1 1.2-10.4-6z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m108 209.7l8.2-48.9-0.6-0.3 1-0.5q0.3-0.2 0.7 0l65.9 38.1c0.5 0.3 1 1.1 0.9 1.6l-8.3 49.3q-0.1 0.4-0.4 0.5l-1 0.6-0.1-0.9-65.5-37.8c-0.5-0.3-0.9-1.1-0.8-1.7z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m182.8 199.4l1.1-0.5c0.1 0.3 0.2 0.6 0.2 0.8l-8.3 49.3q-0.1 0.4-0.4 0.5l-1 0.6-0.1-0.9-3.3-1.9z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m106.9 210.3l8.4-49.3c0-0.5 0.5-0.7 1-0.4l65.9 38c0.5 0.4 0.9 1.2 0.8 1.7l-8.3 49.3c-0.1 0.5-0.5 0.7-1 0.4l-65.9-38c-0.5-0.3-0.9-1.1-0.9-1.7z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m1.4 165.2h-1v-18.1h1z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1.3 174.5h-0.9v-5.1h0.9z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1.3 184h-0.9v-5.1h0.9z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1.3 203h-0.9v-14.6h0.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1.3 212.5h-0.9v-5.1h0.9z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m445.8 242.7h-1v-18.1h1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m445.8 220.4h-0.9v-5.2h0.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m445.8 210.9h-0.9v-5.2h0.9z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m445.8 201.4h-0.9v-14.7h0.9z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m445.8 182.4h-0.9v-5.2h0.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m128.2 67h-0.9v-18.1h0.9z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m128.2 76.3h-1v-5.2h1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m128.2 85.8h-1v-5.2h1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m412.4 75h-0.9v-18.1h0.9z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m412.4 84.3h-1v-5.2h1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m412.4 93.8h-1v-5.2h1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about_us.6922263cecc4ce57d3930072ba682170.svg";
export { ForwardRef as ReactComponent };